<template>
	<div class="appbase">
		<v-navigation-drawer
			:expand-on-hover="false"
			:mini-variant="mini"
			color="secondary"
			app
			permanent
			:width="$vuetify.breakpoint.mdAndDown ? '225' : '256'"
			style="border-radius: 5px;"
		>
			<v-row align="center" justify="center" class="my-3 mx-3" no-gutters>
				<v-spacer></v-spacer>
				<Logo width="50" height="50" />
				<v-spacer></v-spacer>
				<v-btn color="primary" icon @click.stop="mini = !mini" v-if="mini" class="float-right">
					<v-icon>menu</v-icon>
				</v-btn>
				<v-btn color="primary" icon @click.stop="mini = !mini" v-else class="float-right">
					<v-icon>mdi-menu-open</v-icon>
				</v-btn>
			</v-row>
			<v-row
				v-if="!mini && $store.getters.spaceLogo"
				align="center"
				justify="center"
				class="py-4 primary"
				no-gutters
			>
				<v-img :src="$store.getters.spaceLogo" max-width="180" max-height="110" contain/>
			</v-row>
			<v-row no-gutters>
				<v-col cols="12">
					<v-list-item v-if="!mini" class="primary">
						<v-list-item-content>
							<v-list-item-title class="title white--text text-truncate">{{$store.getters.userName}}</v-list-item-title>
							<!-- <v-list-item-subtitle class="white--text">{{$store.getters.spaceName}}</v-list-item-subtitle> -->
						</v-list-item-content>
					</v-list-item>
				</v-col>
			</v-row>
			<v-list nav v-if="!adminSpace && !externalEntitySpace">
				<v-list-item-group>
					<v-list-item :key="4" link color="primary" :to="{name: 'home'}">
						<v-list-item-icon>
							<v-icon color="primary">mdi-home</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title class="primary--text font-weight-medium" v-translate>Dashboard</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
					<v-list-item :key="1" link color="primary" :to="{name: 'calendar'}">
						<v-list-item-icon>
							<v-icon color="primary">calendar_today</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title class="primary--text font-weight-medium" v-translate>Schedule</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
					<v-tooltip v-if="overlay" right :v-model="overlay" color="primary" z-index="400">
						<template v-slot:activator="{ on, attrs }">
							<v-list-item v-bind="attrs" v-on="on" :key="2" link color="primary" :to="{name: 'patients'}" :style="$store.getters.tourStep == 'patients' ? {'position': 'relative', 'z-index': 400, 'background': '#FFFFFF'} : ''">
								<v-list-item-icon>
									<v-icon color="primary">people</v-icon>
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title class="primary--text font-weight-medium" v-translate>Patients</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</template>
						<span>Clique nos pacientes! Clique nos pacientes! Clique nos pacientes! Clique nos pacientes! Clique nos pacientes!</span>
					</v-tooltip>
					<v-list-item v-else :key="2" link color="primary" :to="{name: 'patients'}">
						<v-list-item-icon>
							<v-icon color="primary">people</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title class="primary--text font-weight-medium" v-translate>Patients</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
					<v-list-item :key="3" link color="primary" :to="{name: 'monitoring'}" v-if="$store.getters.hasRole('terapeut')">
						<v-list-item-icon>
							<v-icon color="primary">mdi-chart-line</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title class="primary--text font-weight-medium" v-translate>Monitoring</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list-item-group>
			</v-list>
			<v-list nav v-else-if="adminSpace">
				<v-list-item-group>
					<v-list-item :key="1" link color="primary" :to="{name: 'dashboard'}">
						<v-list-item-icon>
							<v-icon color="primary">mdi-monitor-dashboard</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title class="primary--text font-weight-medium" v-translate>Dashboard</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list-item-group>
			</v-list>
			<v-list nav v-else>
				<v-list-item-group>
					<v-list-item :key="1" link color="primary" :to="{name: 'cmm'}" v-if="externalEntitySpace.verified && externalEntitySpace.cmm">
						<v-list-item-icon class="mr-3">
							<v-icon color="primary">$vuetify.icons.tcmIcon</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title class="primary--text font-weight-medium" v-translate>Chinese Materia Medica</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
					<v-list-item :key="2" link color="primary" :to="{name: 'supplements'}" v-if="externalEntitySpace.verified && externalEntitySpace.supp">
						<v-list-item-icon class="mr-3">
							<v-icon color="primary">mdi-pill</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title class="primary--text font-weight-medium" v-translate>Supplements</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list-item-group>
			</v-list>
			<template v-slot:append>
				<v-list nav>
					<v-list-item-group>
						<v-divider></v-divider>
						<v-list-item
							:key="5"
							link
							color="primary"
							:to="{name: 'modules'}"
							class="mt-2"
							v-if="$store.getters.hasRole('manager') && !adminSpace && !externalEntitySpace"
						>
							<v-list-item-icon>
								<v-icon color="primary">add_to_queue</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title class="primary--text font-weight-medium" v-translate>Subscriptions</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-list-item :key="4" link color="primary" :to="{name: 'settings'}" class="my-1">
							<v-list-item-icon>
								<v-icon color="primary">settings</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title class="primary--text font-weight-medium" v-translate>Settings</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-list-item :key="6" link color="primary" :to="{name: 'support'}" v-if="!adminSpace && !externalEntitySpace">
							<v-list-item-icon>
								<v-icon color="primary">help</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title class="primary--text font-weight-medium" v-translate>Support</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list-item-group>
				</v-list>
				<v-list nav v-if="mini">
					<v-list-item>
						<v-list-item-icon>
							<v-icon color="primary" @click="logout">mdi-power</v-icon>
						</v-list-item-icon>
					</v-list-item>
				</v-list>
				<div v-else class="pa-2">
					<v-btn block color="primary" @click="logout">
						<translate>Logout</translate>
					</v-btn>
				</div>
			</template>
		</v-navigation-drawer>
		<v-main>
			<v-dialog v-model="showAlerts" max-width="70%" scrollable>
				<v-card>
					<v-card-title class="title primary--text mb-5 secondary">
						<translate>Welcome</translate>!
					</v-card-title>
					<v-card-text>
						<v-card color="secondary" v-for="alert in alerts" :key="alert.id" class="mb-2">
							<v-card-title class="primary--text text-subtitle-1">
								<div v-html="alert.title"/>
							</v-card-title>
							<v-card-text>
								<div v-html="alert.text"/>
								<v-img
									v-if="alert.image_url"
									:src="alert.image_url"
									height="400"
									contain
								/>
							</v-card-text>
						</v-card>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-btn color="primary darken-1" @click="hideAlerts" text>
							<translate>Don't show again</translate>
						</v-btn>
						<v-spacer></v-spacer>
						<v-btn color="primary darken-1" @click="showAlerts = false" text>
							<translate>Close</translate>
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<WelcomeTour v-if="showWelcome" v-model="showWelcome" />
			<div style="height: 12px; position: fixed; z-index: 200; width:100%; background:white">
				<v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
			</div>
			<template v-if="!$store.getters.isExternalEntity">
				<v-card key="no-plan" v-if="!$store.getters.hasPlan" class="mx-2 mt-3 mb-0" color="red lighten-2" :to="this.$store.getters.hasRole('manager') ? {name: 'modules'} : {}">
					<v-card-text class="text-center font-weight-bold">
						<v-icon class="mr-2">add_to_queue</v-icon>
						<translate>There is no active plan at the moment. All base functionalities are disabled.</translate>
						<translate v-if="$store.getters.hasRole('manager')" class="ml-1">Click here to subscribe to a plan!</translate>
					</v-card-text>
				</v-card>
				<v-card key="no-modules" v-else-if="!$store.getters.hasAnyModule" class="mx-2 mt-3 mb-0" color="red lighten-2" :to="this.$store.getters.hasRole('manager') ? {name: 'modules'} : {}">
					<v-card-text class="text-center font-weight-bold">
						<v-icon class="mr-2">add_to_queue</v-icon>
						<translate>There is no active module at the moment. All base functionalities are disabled.</translate>
						<translate v-if="$store.getters.hasRole('manager')" class="ml-1">Click here to activate a module!</translate>
					</v-card-text>
				</v-card>
				<v-card key="expiring-plan" v-else-if="$store.getters.hasRole('manager') && $store.getters.hasPlanExpiring && showExpiringModulesAlert" class="mx-2 mt-3 mb-0" color="red lighten-2" :to="this.$store.getters.hasRole('manager') ? {name: 'modules'} : {}">
					<v-btn class="float-right mt-2 mr-2" icon @click="showExpiringModulesAlert = false">
						<v-icon color="white">clear</v-icon>
					</v-btn>
					<v-card-text class="text-center font-weight-bold">
						<v-icon class="mr-2">add_to_queue</v-icon>
						<translate>Your plan will expire in</translate> {{$store.getters.getPlanExpirationDays}} <translate>days</translate>!
						<translate class="ml-1">Click here to extend your subscription!</translate>
					</v-card-text>
				</v-card>
			</template>
			<v-overlay
				:z-index="400"
				:value="overlay"
				style="justify-content: left; align-items: baseline"
				opacity="0.1"
			>
				<v-container fluid>
					<v-row no-gutters>
						<v-card color="white" :style="$store.getters.tourStep == 'appointment-form' ? 'position: absolute; top: 10px; right: 10px' : 'position: absolute; bottom: 10px; right: 10px'" light :loading="loading">
							<v-card-title class="text-subtitle-1 primary--text mb-5 secondary pa-3">
								{{tourTitle}}
							</v-card-title>
							<v-card-text class="text-center body-1" style="min-width: 600px; max-width: 600px; min-height: 100px">
								{{tourText}}
							</v-card-text>
							<v-divider></v-divider>
							<v-card-actions>
								<v-btn small color="primary darken-1" text @click="endTour" :disabled="loading">
									<translate>Finish</translate>
								</v-btn>
								<v-spacer></v-spacer>
								<v-btn v-if="tourEvent != 'end'" key="next" small color="primary darken-1" text @click="nextStep" :disabled="loading">
									<translate>Next</translate>
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-row>
				</v-container>
			</v-overlay>
			<v-container fluid style="padding-top: 12px">
				<router-view :key="$route.fullPath" />
				<v-bottom-sheet
					v-model="showAppointmentsPricing"
					inset
					v-if="usePricing"
					scrollable
				>
					<template v-slot:activator="{ }">
						<v-fab-transition>
							<v-btn
								small
								color="primary"
								fab
								bottom
								right
								fixed
								@click="getAppointmentsPricing"
								:loading="loadingAppointmentsPricing"
							>
								<v-icon>assignment</v-icon>
							</v-btn>
						</v-fab-transition>
					</template>
					<v-sheet rounded>
						<v-card rounded>
							<v-card-text>
								<p v-if="appointmentsPricing.length == 0" class="font-weight-thin ml-5" v-translate>No appointments.</p>
								<v-card class="mx-auto mt-2" v-else v-for="appointment in appointmentsPricing" :key="appointment.id">
									<v-list-item three-line :style="!appointment.effective ? {opacity: 0.8} : {}">
										<v-list-item-content>
											<v-list-item-title class="primary--text">
												<v-row no-gutters class="text-body-1" align="center">
													<v-icon class="mr-1" small color="primary">mdi-account</v-icon>
													<span class="mr-2">{{appointment.patient.name}}</span>
													<span class="mr-2">|</span>
													<v-icon class="mr-1" small color="primary">mdi-account-tie</v-icon>
													<span class="mr-2">{{appointment.user.name}}</span>
													<v-icon class="mr-1" small color="primary">mdi-certificate</v-icon>
													<span>{{appointment.speciality.name}}</span>
													<v-spacer></v-spacer>
													<template v-if="!appointment.effective">
														<v-chip class="mr-2" small><translate>Scheduled</translate></v-chip>
													</template>
													<v-icon class="mr-1" small color="primary">mdi-calendar</v-icon>
													<span class="mr-2">{{appointment.date}}</span>
													<v-icon class="mr-1" small color="primary">mdi-clock-outline</v-icon>
													<span>{{appointment.time}}</span>
												</v-row>
												<v-row no-gutters class="my-2 text-body-2">
													<template v-if="appointment.appointment_type">
														<v-icon class="mr-1" small color="primary">mdi-arrow-right-thin-circle-outline</v-icon>
														<span class="mr-2">{{appointment.appointment_type.name}}</span>
													</template>
													<template v-if="appointment.appointment_location">
														<v-icon class="mr-1" small color="primary">mdi-door</v-icon>
														<span class="mr-2">{{appointment.appointment_location.name}}</span>
													</template>
												</v-row>
											</v-list-item-title>
											<v-list-item-subtitle>
												{{appointment.description}}
											</v-list-item-subtitle>
										</v-list-item-content>
									</v-list-item>
									<v-divider class="mx-4"></v-divider>
									<v-card-text v-if="appointment.effective">
										<v-row no-gutters>
											<span v-if="appointment.price_notes">{{appointment.price_notes}}</span>
											<v-spacer></v-spacer>
											<span class="text-h5 font-weight-light primary--text" v-if="appointment.price != null">
												<v-icon class="mr-1" color="primary">mdi-check-circle</v-icon>
												{{appointment.price}}€
											</span>
											<span v-else class="text-h5 font-weight-light grey--text">
												<v-btn icon @click="setAppointmentPrice(appointment)">
													<v-icon color="grey">mdi-check-circle-outline</v-icon>
												</v-btn>
												{{$store.getters.appointmentPrice(appointment.id)}}€
											</span>
										</v-row>
									</v-card-text>
								</v-card>
							</v-card-text>
							<v-divider></v-divider>
							<v-card-actions>
								<v-btn color="primary" text @click="showAppointmentsPricing = false">
									<translate>Close</translate>
								</v-btn>
								<v-spacer></v-spacer>
								<!-- <v-btn color="primary" text @click="saveAppointmentPrice" :loading="false">
									<translate>Save</translate>
								</v-btn> -->
							</v-card-actions>
						</v-card>
					</v-sheet>
				</v-bottom-sheet>
			</v-container>
		</v-main>
	</div>
</template>

<script>
import Logo from "@/assets/logos/Logo.vue";
import WelcomeTour from "@/views/app/WelcomeTour.vue";
import axios from "axios";

export default {
	name: "AppBase",
	data: () => ({
		mini: false,
		showAlerts: false,
		showExpiringModulesAlert: true,
		showWelcome: false,
		showAppointmentsPricing: false,
		loadingAppointmentsPricing: false,
		appointmentsPricing: []
	}),
	components: {
		Logo,
		WelcomeTour
	},
	methods: {
		logout() {
			this.$store
				.dispatch("LOGOUT")
				.then(response => {
					console.log(response);
					this.$router.push("/login").then(this.$store.dispatch("REMOVE_USER"));
				})
				.catch(error => {
					console.log(error);
				});
		},
		hideAlerts() {
			this.$store.dispatch("HIDE_ALERTS").then(this.showAlerts = false);
		},
		beginTour() {
			this.$store.dispatch('BEGIN_TOUR');
			this.$router.push({name: 'home'});
		},
		endTour() {
			this.$store.dispatch('END_TOUR');
			this.$router.push({name: 'home'});
		},
		nextStep() {
			this.$store.dispatch('NEXT_STEP_TOUR');
		},
		getAppointmentsPricing() {
			console.log("CLICK");
			this.loadingAppointmentsPricing = true;
			axios
				.get("/appointments-pricing")
				.then(response => {
					console.log(response.data);
					this.appointmentsPricing = response.data.appointments;
					this.$store.dispatch("SET_APPOINTMENTS", response.data.appointments);
					this.$store.dispatch("SET_PRICES_INFO", response.data.price_info);
					this.loadingAppointmentsPricing = false;
					this.showAppointmentsPricing = true;
				})
				.catch(error => {
					console.log(error);
					this.loadingAppointmentsPricing = false;
				});
		},
		setAppointmentPrice(appointment) {
			let price = this.$store.getters.appointmentPrice(appointment.id);
			let form = new FormData();
			form.append("price", price);
			axios
				.post("/appointment/" + appointment.id + "/pricing", form)
				.then(response => {
					console.log(response.data);
					appointment.price = response.data.price;
				})
				.catch(error => {
					console.log(error);
				});
		}
	},
	computed: {
		overlay() {
			return this.$store.getters.tourMode;
		},
		tourTitle() {
			return this.$store.getters.tourTitle;
		},
		tourText() {
			return this.$store.getters.tourText;
		},
		tourEvent() {
			return this.$store.getters.tourStepEvent;
		},
		loading() {
			return this.$store.getters.LOADING;
		},
		alerts() {
			return this.$store.getters.alerts;
		},
		adminSpace() {
			return this.$store.getters.spaceId == 7;
		},
		externalEntitySpace() {
			return this.$store.getters.externalEntity;
		},
		usePricing() {
			return this.$store.getters.pricing && this.$store.getters.hasRole("receptionist") && !this.$store.getters.hasRole("manager");
		}
	},
	mounted() {
		if (this.$vuetify.breakpoint.mdAndDown) this.mini = true;
		if (this.$store.getters.firstTime && !this.externalEntitySpace) this.showWelcome = true;
		else if (this.$store.getters.alerts.length > 0) this.showAlerts = true;
	}
};
</script>

<style scoped>

>>> .v-overlay__content {
	height: 100%;
	width: 100%;
}
</style>